export default __webpack_public_path__ + "static/media/Massage.7d9677ad.svg";